// STYLES
import * as Style from "./ModalAtomStyle";

// LIBRARIES
import { Modal } from "@mui/material";

// MISC
import { IModalData, IChildModalData } from "./ModalAtomModel";
import { ChildModalTypes, ModalTypes } from "models/GeneralTypes/generalTypes";

// ASSETS

// REDUX
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import {
  toggleModalState,
  modalProps,
  childModalProps,
  toggleChildModalState,
  loadingState,
} from "slices/uiSlice";

// COMPONENTS
import UsersDetails from "./Content/UsersDetails/UsersDetails";
import RentalDetails from "./Content/RentalDetails/RentalDetails";
import DoorDetails from "./Content/DoorDetails/DoorDetails";
import ConfirmationModal from "./Content/ConfirmationModal/ConfirmationModal";
import Notifications from "./Content/Notifications/Notifications";
import AddSupportItem from "./Content/AddSupportItem/AddSupportItem";
import EditSupportItem from "./Content/EditSupportItem/EditSupportItem";
import Settings from "./Content/Settings/Settings";
import Language from "./Content/Language/Language";
import EditUserStatus from "./Content/EditUserStatus/EditUserStatus";
import PowerUpModal from "./Content/PowerUpModal/PowerUpModal";
import SelectUsers from "./Content/SelectUsers/SelectUsers";
import EditPromoCode from "./Content/EditPromoCode/EditPromoCode";
import AddNewLocker from "./Content/AddNewLocker/AddNewLocker";

const ModalAtom = () => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const modalData = useAppSelector<IModalData>(modalProps);
  const isLoading = useAppSelector<boolean>(loadingState);
  const childModalData = useAppSelector<IChildModalData>(childModalProps);

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleClose = (event?, reason?) => {
    if (
      modalData.type === ModalTypes.NOTIFICATION ||
      modalData.type === ModalTypes.LANGUAGE
    ) {
      dispatch(
        toggleModalState({
          ...modalData,
          isVisible: false,
        })
      );
    } else if (reason !== "backdropClick") {
      dispatch(
        toggleModalState({
          ...modalData,
          isVisible: false,
          user: null,
          report: null,
          discount: null,
        })
      );
    } else if (reason !== "backdropClick" && ModalTypes.USER) {
      dispatch(
        toggleModalState({
          ...modalData,
          isVisible: false,
          user: null,
          report: null,
          discount: null,
          rentalUser: false,
        })
      );
    } else if (reason === "backdropClick" && ChildModalTypes.POWER_UP) {
      dispatch(
        toggleModalState({
          ...modalData,
          isVisible: false,
          user: null,
          report: null,
          discount: null,
          rentalUser: false,
        })
      );
    }
  };
  const handleCloseChildModal = () =>
    dispatch(toggleChildModalState({ isVisible: false }));

  const handleRenderContent = () => {
    switch (modalData.type) {
      case ModalTypes.USER:
        return <UsersDetails handleClose={handleClose} />;
      case ModalTypes.RENTAL:
        return <RentalDetails handleClose={handleClose} />;
      case ModalTypes.DOOR:
        return <DoorDetails handleClose={handleClose} />;
      case ModalTypes.DISCOUNT_DELETE_CONFIRMATION:
        return <ConfirmationModal handleClose={handleClose} />;
      case ModalTypes.NOTIFICATION:
        return <Notifications handleClose={handleClose} />;
      case ModalTypes.SETTINGS:
        return <Settings handleClose={handleClose} />;
      case ModalTypes.LANGUAGE:
        return <Language handleClose={handleClose} />;
      case ModalTypes.ADD_CATEGORY:
      case ModalTypes.ADD_SUBCATEGORY:
      case ModalTypes.ADD_ARTICLE:
        return <AddSupportItem handleClose={handleClose} />;
      case ModalTypes.EDIT_CATEGORY:
      case ModalTypes.EDIT_SUBCATEGORY:
      case ModalTypes.EDIT_ARTICLE:
        return <EditSupportItem handleClose={handleClose} />;
      case ModalTypes.EDIT_USER_STATUS:
        return <EditUserStatus handleClose={handleClose} />;
      case ChildModalTypes.POWER_UP:
        return <PowerUpModal />
      case ModalTypes.SELECT_USERS:
        return <SelectUsers handleClose={handleClose} />
      case ModalTypes.EDIT_PROMO_CODE:
        return <EditPromoCode handleClose={handleClose} />
      case ModalTypes.ADD_NEW_LOCKER:
        return <AddNewLocker handleClose={handleClose} />
    }
  };

  const handleRenderChildContent = () => {
    switch (childModalData.type) {
      case ChildModalTypes.ID:
        return (
          <Style.ChildModalIdContainer src={childModalData.content} alt="" />
        );
      case ChildModalTypes.EQUIPMENT:
        return (
          <Style.ChildModalEquipmentPhotoContainer
            src={childModalData.content}
            alt=""
          >
            {/* <Style.CloseIconContainer>
              <Style.CloseIcon
                onClick={() => handleCloseChildModal()}
              />
            </Style.CloseIconContainer> */}
          </Style.ChildModalEquipmentPhotoContainer>
        );
      case ChildModalTypes.POWER_UP:
        return <PowerUpModal />
    }
  };

  return (
    <Style.ModalDialog
      type={
        (modalData.type === ModalTypes.NOTIFICATION && "transparent") ||
        (modalData.type === ModalTypes.LANGUAGE && "transparent")
      }
      open={modalData?.isVisible || false}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <>
        {handleRenderContent()}
        {childModalData.isVisible && (
          <Modal
            open={childModalData?.isVisible || false}
            onClose={handleCloseChildModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Style.ChildModalDialog>
            <Style.CloseIconContainer>
              <Style.CloseIcon
                onClick={() => handleCloseChildModal()}
              />
            </Style.CloseIconContainer>
              <Style.ChildModalEquipmentPhotoContainer
                src={childModalData.content}
                alt=""
              />
            </Style.ChildModalDialog>
          </Modal>
        )}
        ;
        {isLoading && (
          <Modal
            open={isLoading}
            onClose={null}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <>
              <Style.LoadingModalContainer>
                <Style.ContentWrapper>
                  <Style.LodingSign />
                </Style.ContentWrapper>
              </Style.LoadingModalContainer>
            </>
          </Modal>
        )}
        ;
      </>
    </Style.ModalDialog>
  );
};

export default ModalAtom;
